export default __webpack_public_path__ + "static/media/Youth_Illustrations-Echo.1578af8a.png";